import { c as _c } from "react/compiler-runtime";
import { colors, Padding, Text, LineClamp, Stack, IconButton, Input, Tooltip } from '@newfront-insurance/core-ui';
import type { JSX } from 'react';
import styled from 'styled-components';
import { useDefinitionsHelpers } from '../../../hooks/definitions';
import type { LineOfCoverageTypeDetails } from '../../../types';
interface Props {
  index: number;
  lineOfCoverage: LineOfCoverageTypeDetails;
  onRemove: (index: number, isDeleting?: boolean) => void;
  onDisplayNameChange: (index: number, displayName: string) => void;
}
export function LineOfCoverageTypeCard(t0) {
  const $ = _c(28);
  const {
    lineOfCoverage,
    onRemove,
    onDisplayNameChange,
    index
  } = t0;
  const {
    renderLineOfCoverageType
  } = useDefinitionsHelpers();
  let t1;
  if ($[0] !== lineOfCoverage.type || $[1] !== renderLineOfCoverageType) {
    t1 = renderLineOfCoverageType(lineOfCoverage.type);
    $[0] = lineOfCoverage.type;
    $[1] = renderLineOfCoverageType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const readableName = t1;
  const existentLoc = !!lineOfCoverage.uuid;
  const t2 = existentLoc ? "Delete coverage" : "Deselect coverage";
  const t3 = existentLoc ? "remove" : "close";
  let t4;
  if ($[3] !== existentLoc || $[4] !== index || $[5] !== onRemove) {
    t4 = () => onRemove(index, !!existentLoc);
    $[3] = existentLoc;
    $[4] = index;
    $[5] = onRemove;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <IconButton type={t3} onClick={t4} />;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <StyledActionMenu className="card-menu"><Tooltip text={t2} positionTip="left">{t5}</Tooltip></StyledActionMenu>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== readableName) {
    t7 = <Text weight={600} color="dark" truncate={true}><LineClamp numOfLines={2}>{readableName}</LineClamp></Text>;
    $[13] = readableName;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      border: 0,
      padding: 0,
      height: 18
    };
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = lineOfCoverage.displayName ?? "";
  let t10;
  if ($[16] !== index || $[17] !== onDisplayNameChange) {
    t10 = displayName => onDisplayNameChange(index, displayName);
    $[16] = index;
    $[17] = onDisplayNameChange;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <Text><LineClamp numOfLines={2}><Input type="text" style={t8} value={t9} placeholder="Add a display name..." onChange={t10} /></LineClamp></Text>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t7) {
    t12 = <Padding size={16} right={20}><Stack gap={4} direction="vertical">{t7}{t11}</Stack></Padding>;
    $[22] = t11;
    $[23] = t7;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t6) {
    t13 = <StyledRow>{t6}{t12}</StyledRow>;
    $[25] = t12;
    $[26] = t6;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
}
const StyledActionMenu = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
`;
const StyledRow = styled.div`
  background-color: white;
  border: 1px solid ${colors.steel[200]};
  border-radius: 6px;
  position: relative;
`;